import React, { Component } from "react";
import MetaTags from 'react-meta-tags';
import styled from 'styled-components';
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Jumbotron from 'react-bootstrap/Jumbotron'
import Breadcrumb from 'react-bootstrap/Breadcrumb'

const ContentStyles = styled.div`
  
`;


class NotFound extends Component {
  render() {
    return (
      <>
        <MetaTags>
          <title>Aradığınız sayfa bulunamadı | Emlak Katılım Mortgage</title>
          <meta name="description" content="Aradığınız sayfa bulunamadı" />
          <meta property="og:title" content="Aradığınız sayfa bulunamadı | Emlak Katılım Mortgage" />
          <meta property="og:image" content="Aradığınız sayfa bulunamadı" />
        </MetaTags>
        <ContentStyles>
          <Jumbotron className="subpageHeader" fluid>
            <Container>
              <h1>404 - Sayfa Bulunamadı</h1>
              <Breadcrumb>
                <Breadcrumb.Item href="/">Ana Sayfa</Breadcrumb.Item>
                <Breadcrumb.Item active>404 - Sayfa Bulunamadı</Breadcrumb.Item>
              </Breadcrumb>
            </Container>
          </Jumbotron>
          <Container>
            <Row>
              <Col className="subpageContent">
                <h2>Özür dileriz</h2>
                <p>Aradığınız sayfayı maalesef bulamadık!</p>
                <p><a href="/">Ana Sayfaya Dön</a></p>
              </Col>
            </Row>
          </Container>
        </ContentStyles>
      </>
    );
  }
}

export default NotFound;